import { Navigate, useParams, useSearchParams } from "react-router-dom";

import { careerProfilePathFromLatest } from "./careerPlanLatest";

export default function CareerProfileLatestRedirect() {
  const { pgaId } = useParams();
  const [searchParams] = useSearchParams();

  if (!pgaId) return null;

  return <Navigate to={careerProfilePathFromLatest(pgaId, searchParams)} replace />;
}
